import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk'
import { Provider } from 'react-redux'
import reducers from './reducers'
import logger from 'redux-logger'

const store = createStore(reducers, applyMiddleware(thunk,logger));

const ReduxApp = (
  <Provider store = {store}>
      <App/>
  </Provider>
)

ReactDOM.render(ReduxApp, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
